import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './bootstrap.css'
import './styles/base.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
// import { ThemeContext } from './Context/ThemeContext';
import { store } from './Store/store';
import './i18n'; // important: runs the init
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store = {store}>
      <BrowserRouter basename='/'>
        {/* <ThemeContext>           */}
        <I18nextProvider i18n={i18n}>
          <App/>
        </I18nextProvider>
        {/* </ThemeContext> */}
      </BrowserRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
